import orderflowHelper from '@/config/order'
export let filterFactor = [{
  label: '异常步骤',
  type: 'select',
  clearable: true,
  value: 'orderActions', // 需返回数据的字段名
  options: getLabStatusOptions()
}]
// 原因应该用的 orderActionData.message 然后结果 用的是orderActionData.statusDetail.reason
export let tableLabels = [{
  label: '样本条码号',
  minWidth: '110',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '实验室唯一码',
  minWidth: '110',
  value: 'orderActionData.order.currentSample.labCode'
},
{
  label: '当前样本板编号',
  minWidth: '110',
  value: 'orderActionData.order.processSamplePlateName'
},
{
  label: '样本板孔位',
  minWidth: '110',
  value: 'orderActionData.order.chipSlotPosition'
}, {
  label: '客户名称',
  minWidth: '150',
  value: 'orderActionData.order.clientOrganization.fullName'
}, {
  label: '样本接收单号',
  minWidth: '110',
  value: 'orderActionData.order.batchNumber'
},
//  {
//   label: '芯片ID',
//   value: 'orderActionData.order.chipId'
// },
{
  label: '样本类型',
  value: 'orderActionData.order.currentSample.sampleType'
}, {
  label: '受检人',
  value: 'orderActionData.order.patient.name'
}, {
  label: '实验室产品',
  minWidth: '110',
  value: 'orderActionData.order.product.name'
}, {
  label: '异常步骤', // 下一状态
  value: 'orderActionData.nextAction',
  minWidth: '100'
}, {
  label: '处理原因',
  minWidth: '140',
  value: 'reason'
}, {
  label: '备注',
  minWidth: '140',
  value: 'orderActionData.statusDetail.comment'
}, {
  label: '提交时间',
  value: 'createdDate',
  minWidth: '100'
}]

export let tableLabelsOk = [{
  label: '样本条码号',
  minWidth: '110',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '实验室唯一码',
  minWidth: '110',
  value: 'orderActionData.order.currentSample.labCode'
},
{
  label: '当前样本板编号',
  minWidth: '110',
  value: 'orderActionData.order.processSamplePlateName'
},
{
  label: '样本板孔位',
  minWidth: '110',
  value: 'orderActionData.order.chipSlotPosition'
}, {
  label: '客户名称',
  minWidth: '150',
  value: 'orderActionData.order.clientOrganization.fullName'
}, {
  label: '样本接收单号',
  minWidth: '110',
  value: 'orderActionData.order.batchNumber'
},
// {
//   label: '芯片ID',
//   value: 'orderActionData.order.chipId'
// },
{
  label: '样本类型',
  value: 'orderActionData.order.currentSample.sampleType'
}, {
  label: '受检人',
  value: 'orderActionData.order.patient.name'
}, {
  label: '实验室产品',
  minWidth: '110',
  value: 'orderActionData.order.product.name'
}, {
  label: '已处理操作', // 下一状态
  value: 'orderActionData.nextAction',
  minWidth: '100'
}, {
  label: '处理原因',
  minWidth: '140',
  value: 'reason'
}, {
  label: '备注',
  minWidth: '140',
  value: 'orderActionData.statusDetail.comment'
}, {
  label: '提交时间',
  value: 'createdDate',
  minWidth: '100'
}, {
  label: '处理结果',
  value: 'result',
  minWidth: '100'
}]
export let tableLabelsCreated = [{
  label: '样本条码号',
  minWidth: '130',
  value: 'orderActionData.order.currentSample.sampleId'
}, {
  label: '样本接收单号',
  minWidth: '110',
  value: 'orderActionData.order.batchNumber'
}, {
  label: '客户样本板编号',
  minWidth: '130',
  value: 'orderActionData.order.customerBoardNumber'
}, {
  label: '孔位',
  value: 'orderActionData.order.customerPosition'
}, {
  label: '客户产品',
  value: 'orderActionData.order.product.name'
}, {
  label: '样本类型',
  value: 'orderActionData.order.currentSample.sampleType'
}, {
  label: '错误描述',
  value: 'reason',
  minWidth: '150'
}]
function getLabStatusOptions () {
  let options = []
  orderflowHelper.getDefaultOrderFlow().forEach(item => {
    if (item.name !== 'COMPLETED' && item.name !== 'CLOSED' && item.name !== 'LAB_SAMPLE_RETURNED' && item.name !== 'DATA_ANALYSISED') {
      let signalItem = {
        label: item.operation,
        value: item.name
      }
      options.push(signalItem)
    }
  })
  // 二代测序
  let action = [{
    label: '文库质检',
    value: 'LIBRARY_QUALITY_INSPECT'
  }, {
    label: '上机测序',
    value: 'LAB_DNA_TESTED'
  }, {
    label: '数据回传',
    value: 'DATA_RETURN'
  }, {
    label: '数据质控',
    value: 'DATA_ANALYSISED'
  }]
  return options.concat(action)
}
